import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import type { DocumentDatabase } from "../../../types";
import { keys } from "./keys";

export type EntityDocFilter = {
  communicationId?: string;
  quoteId?: string;
  incidentId?: string;
  eventId?: string;
  documentId?: string;
  subjectActionId?: string;
};

async function fetchDocumentsByEntity(filter: EntityDocFilter): Promise<DocumentDatabase[]> {
  let query = apiClient
    .from('documents')
    .select('*, document_types:document_type_id(id, name)')
    .order('created_at', { ascending: false });

  if (filter.communicationId) {
    query = query.eq('communication_id', filter.communicationId);
  } else if (filter.quoteId) {
    query = query.eq('quote_id', filter.quoteId);
  } else if (filter.incidentId) {
    query = query.eq('incident_id', filter.incidentId);
  } else if (filter.eventId) {
    query = query.eq('event_id', filter.eventId);
  } else if (filter.documentId) {
    query = query.eq('id', filter.documentId);
  } else if (filter.subjectActionId) {
    query = query.eq('subject_action_id', filter.subjectActionId);
  }

  const { data, error } = await query;

  if (error) {
    throw error;
  }

  return (data ?? []).map((doc) => ({
    ...doc,
    type: doc.document_types?.name ?? null,
  }));
}

export function useGetDocumentsByEntity(filter: EntityDocFilter, enabled = true) {
  const filterKey = filter.communicationId || filter.quoteId || filter.incidentId || filter.eventId || filter.documentId || filter.subjectActionId || '';

  return useQuery({
    queryKey: [...keys.all, 'entityDocuments', filter],
    queryFn: () => fetchDocumentsByEntity(filter),
    enabled: Boolean(filterKey) && enabled,
  });
}
